import logo from "./Assets/cube.jpeg";
import supercare from "./Assets/sc-logo.png";
import { useAuth } from "./authContext";
import { useState } from "react";

const NoAccessPage = () => {
  const { url } = useAuth();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^0-9+\-\s]/g, '');
    setPhoneNumber(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phoneNumber.trim()) {
      setMessage("Please enter your phone number");
      return;
    }

    setIsLoading(true);
    setMessage("");

    try {
      const response = await fetch(`${url}/wellness/session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          msisdn: phoneNumber,
          source: "manual"
        })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Access granted! Redirecting...");
        sessionStorage.setItem('msisdn', phoneNumber);
        const encodedAccess = btoa(phoneNumber);
        sessionStorage.setItem('encoded_access', encodedAccess);
        //console.log("Success:", data);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        setMessage(data.message || "Access denied. Please check your phone number.");
      }
    } catch (error) {
      setMessage("Error validating access. Please try again.");
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="h-screen bg-white relative overflow-hidden flex flex-col">
      <div className="p-2 sm:p-6 flex-shrink-0">
        <div className="flex items-center gap-2 sm:gap-3">
          <img
            src={logo}
            alt="WellnessAI"
            className="w-6 h-6 sm:w-12 sm:h-12 rounded-full shadow-md"
          />
          <span className="text-base sm:text-2xl font-bold text-gray-900">
            WellnessAI
          </span>
        </div>
      </div>

      <div className="flex-1 flex flex-col justify-center px-4 sm:px-6 py-6 sm:py-8">
        <div className="text-center mb-6 sm:mb-12">
          <h1 className="text-lg sm:text-4xl md:text-7xl font-extrabold text-black mb-3 sm:mb-4 leading-tight drop-shadow-sm">
            Welcome to WellnessAI
          </h1>
          <p className="text-sm sm:text-lg md:text-2xl text-black font-medium">
            Your AI-powered companion for better health and wellness
          </p>
        </div>

        <div className="max-w-md mx-auto w-full">
          <form onSubmit={handleSubmit} className="mb-4 sm:mb-6">
            <div className="mb-3 sm:mb-4">
              <input
                type="tel"
                placeholder="Enter your phone number"
                value={phoneNumber}
                onChange={handlePhoneChange}
                className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg sm:rounded-xl text-base sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                disabled={isLoading}
                style={{ fontSize: '16px' }}
              />
            </div>
            <button
              type="submit"
              disabled={isLoading || !phoneNumber.trim()}
              className={`w-full py-2 sm:py-3 px-4 sm:px-6 rounded-lg sm:rounded-xl text-white font-semibold text-sm sm:text-base transition-all duration-300 transform hover:scale-105 ${
                isLoading || !phoneNumber.trim()
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-sky-500 hover:bg-sky-600 shadow-lg'
              }`}
            >
              {isLoading ? "Validating..." : "Start Your Wellness Journey"}
            </button>
          </form>

          {message && (
            <div className={`p-3 sm:p-4 rounded-lg sm:rounded-xl mb-4 text-xs sm:text-sm font-medium ${
              message.includes("granted") 
                ? 'bg-green-100 text-green-700 border border-green-300' 
                : 'bg-red-100 text-red-700 border border-red-300'
            }`}>
              {message}
            </div>
          )}
        </div>
      </div>

      <div className="fixed bottom-0 right-0 p-3" style={{ zIndex: 50 }}>
        <img 
          src={supercare} 
          alt="Logo" 
          className="w-20 h-30" 
          style={{
            animation: 'flipX 3s linear infinite',
            transformStyle: 'preserve-3d'
          }}
        />
      </div>

      <style>{`
        @keyframes flipX {
          0% {
            transform: rotateY(0deg);
          }
          50% {
            transform: rotateY(180deg);
          }
          100% {
            transform: rotateY(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default NoAccessPage;
